import { render, staticRenderFns } from "./Invention.vue?vue&type=template&id=a3483ab8"
import script from "./Invention.vue?vue&type=script&lang=js"
export * from "./Invention.vue?vue&type=script&lang=js"
import style0 from "./Invention.vue?vue&type=style&index=0&id=a3483ab8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3483ab8')) {
      api.createRecord('a3483ab8', component.options)
    } else {
      api.reload('a3483ab8', component.options)
    }
    module.hot.accept("./Invention.vue?vue&type=template&id=a3483ab8", function () {
      api.rerender('a3483ab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Invention.vue"
export default component.exports